import { useEffect, useState } from 'react'
import {
  applyTheme,
  getStoredTheme,
  setTheme,
  THEME_ORDER,
  type Theme,
  themeLabel,
} from '../lib/theme.ts'
import './themetoggle.css'

function Icon({ theme }: { theme: Theme }) {
  if (theme === 'system') {
    return (
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden>
        <rect x="3" y="4" width="18" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
        <path d="M9 20h6M12 16v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    )
  }
  if (theme === 'light') {
    return (
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden>
        <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8" />
        <path
          d="M12 2v2M12 20v2M4 12H2M22 12h-2M5 5l1.5 1.5M17.5 17.5L19 19M19 5l-1.5 1.5M6.5 17.5L5 19"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    )
  }
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden>
      <path
        d="M20 14.5A8 8 0 019.5 4 8 8 0 1020 14.5z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ThemeToggle() {
  const [theme, setThemeState] = useState<Theme>(getStoredTheme)

  // Följ systemet i realtid när "Följ systemet" är valt.
  useEffect(() => {
    if (theme !== 'system') return
    const mq = window.matchMedia('(prefers-color-scheme: dark)')
    const onChange = () => applyTheme('system')
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [theme])

  const cycle = () => {
    const next = THEME_ORDER[(THEME_ORDER.indexOf(theme) + 1) % THEME_ORDER.length] as Theme
    setTheme(next)
    setThemeState(next)
  }

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={cycle}
      title={`Tema: ${themeLabel(theme)} (klicka för att byta)`}
      aria-label={`Tema: ${themeLabel(theme)}`}
    >
      <Icon theme={theme} />
    </button>
  )
}
